import PropTypes from "prop-types";

import { StateField } from "UI/FnrAddress";

import { useAutocompleteContext } from "./AutocompleteContext";

/**
 * State field auto-wired to the autocomplete context. State is a
 * dropdown so it does not use ShadowField — shadow + onShadowCommit
 * are wired directly on StateField. When the candidate disagrees with a
 * stale state, the hook's clear-stash-restore effect empties `value.state`
 * so the candidate renders as the dropdown's ghost.
 *
 * Consumer-controlled StateField props are forwarded explicitly (add new ones
 * here as a surface needs them); `onMenuChange` exists for the Network Settings
 * popover-tracking case.
 */
export default function AutocompleteStateField({
  disabled,
  countryIDOrCode,
  onMenuChange,
}) {
  const { value, onChange, shadows, onFieldBlur } = useAutocompleteContext();
  return (
    <StateField
      disabled={disabled}
      value={value.state || ""}
      onChange={(val) => onChange({ state: val })}
      countryIDOrCode={countryIDOrCode}
      onMenuChange={onMenuChange}
      shadow={shadows.state}
      // The dropdown's accept (tab-through / right-arrow) is an EXPLICIT
      // per-field accept, like Tab/ArrowRight on the text fields — so pass
      // `explicit=true`. Without it the hold-mode guard in onFieldBlur
      // (`holdTypedValues && !explicit`) drops the commit and the state ghost
      // persists instead of filling in (admin profile, reports popover). The
      // menu-open case never reaches here — StateField filters it first.
      onShadowCommit={() => onFieldBlur("state", true)}
    />
  );
}

AutocompleteStateField.propTypes = {
  disabled: PropTypes.bool,
  countryIDOrCode: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onMenuChange: PropTypes.func,
};
